import { render, staticRenderFns } from "./cancelRuleList.vue?vue&type=template&id=2ff1e0e4&scoped=true"
import script from "./cancelRuleList.vue?vue&type=script&lang=js"
export * from "./cancelRuleList.vue?vue&type=script&lang=js"
import style0 from "./cancelRuleList.vue?vue&type=style&index=0&id=2ff1e0e4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff1e0e4",
  null
  
)

export default component.exports